import { fireOperationalEvent } from '@atlassian/ui-modifications-analytics';
import { baseRequiredReadScopes, baseRequiredWriteScopes } from './screen-tabs-scopes';
var includeCoarseScopes = function includeCoarseScopes(requiredScopes, moduleScopes) {
  return requiredScopes.coarse.length > 0 && requiredScopes.coarse.every(function (requiredScope) {
    return moduleScopes.includes(requiredScope);
  });
};
var includeGranularScopes = function includeGranularScopes(requiredScopes, moduleScopes) {
  return requiredScopes.granular.length > 0 && requiredScopes.granular.every(function (requiredScope) {
    return moduleScopes.includes(requiredScope);
  });
};
export var filterScreenTabsBasedOnReadScopes = function filterScreenTabsBasedOnReadScopes(moduleScopes, screenTabs) {
  if (includeCoarseScopes(baseRequiredReadScopes, moduleScopes) || includeGranularScopes(baseRequiredReadScopes, moduleScopes)) {
    return screenTabs;
  }
  return [];
};
export var moduleIncludesScreenTabsWriteScopes = function moduleIncludesScreenTabsWriteScopes(viewType, createAnalyticsEvent, moduleScopes, screenTabsChanges) {
  if (includeCoarseScopes(baseRequiredWriteScopes, moduleScopes) || includeGranularScopes(baseRequiredWriteScopes, moduleScopes)) {
    return true;
  }
  if (Array.isArray(screenTabsChanges) && screenTabsChanges.length > 0) {
    fireOperationalEvent(createAnalyticsEvent, {
      action: 'missingScope',
      actionSubject: 'jiraUiModifications.screenTabs',
      attributes: {
        access: 'write',
        viewType: viewType
      }
    });
  }
  return false;
};